import { useParams } from 'react-router-dom';
import ContentPaper from '../../../../components/layouts/rfs/Content';
import RfsLayout from '../../../../components/layouts/RfsLayout';
import { useEffect, useState } from 'react';
import { AppLoader } from '../../../../components/common/loader';
import Info from './info';

const ExtensionInfo = () => {
  const { erId } = useParams();
  const [requestType, setRequestType] = useState(undefined);

  useEffect(() => {
    const type = erId.split('-')[0];
    setRequestType(['AVIC', 'PIR', 'SP'].includes(type) ? type : undefined);
  }, [erId]);

  return (
    <RfsLayout>
      <ContentPaper>
        {!requestType ? (
          <AppLoader center size='lg' />
        ) : (
          <Info requestType={requestType} erId={erId} />
        )}
      </ContentPaper>
    </RfsLayout>
  );
};

export default ExtensionInfo;
